import React from 'react';

const LDAPAdapterDocumentation = () => <div />;

export default LDAPAdapterDocumentation;
